var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.hideEmojies,
          expression: "hideEmojies"
        }
      ],
      staticClass: "rich-text-bar"
    },
    [
      _c("vue-media", {
        attrs: { query: { maxWidth: 767.98 } },
        on: { "media-enter": _vm.mediaEnter, "media-leave": _vm.mediaLeave }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "option-placeholders" }, [
        _vm.emojiesAlowed
          ? _c(
              "button",
              {
                class: {
                  emojies: true,
                  "close-popup": _vm.isEmojiPickerActive
                },
                attrs: { tabindex: "-1" },
                on: { click: _vm.showEmojies }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _vm._v("\n        " + _vm._s(_vm.emojiLabel) + "\n      ")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rich-editor-container" },
                  [
                    _c(_vm.emojiPickerLoader, {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.emojiesShown && _vm.emojiPickerLoader,
                          expression: "emojiesShown && emojiPickerLoader"
                        }
                      ],
                      tag: "component",
                      attrs: {
                        showPreview: false,
                        emojiTooltip: false,
                        native: "",
                        title: _vm.$t("Button.pickEmoji")
                      },
                      on: { click: _vm.useEmoji }
                    })
                  ],
                  1
                )
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dec3a9e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dec3a9e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/input/RichTextOptions.vue
// module id = null
// module chunks = 